<template>
  <pf-radio
    v-for="(v, k) of opzioniLocation"
    :key="k"
    :name="name"
    required
    :disabled="disabled"
    :value="k"
    :checked="k === modelValue"
    @change="$emit('update:modelValue', k as (typeof REGION)[number])"
  >
    <template #label> {{ emojiflag(k.slice(0, 2)) }} {{ v }} </template>
  </pf-radio>
</template>

<script setup lang="ts">
import { REGION } from '@common/consts';
import { emojiflag, locations } from '@common/utils';
import { useWizardQuestion } from '@/wizard';

defineProps<{
  modelValue: (typeof REGION)[number] | undefined;
  name: string;
  opzioniLocation: Partial<typeof locations>;
  disabled?: boolean;
}>();

defineEmits<{
  (name: 'update:modelValue', v: (typeof REGION)[number]): void;
}>();

useWizardQuestion();
</script>
